export default ({ store: { getters }, redirect }) => {
    if (getters['auth/isLoggedIn']) {
        redirect('/');
    }
};
